<template>
    <div class="category-discount-progress" v-if="rule">
        <b class="category-discount-progress__title">{{ $translate("OD3dprimaV2::Template.categoryDiscountTitle") }}</b>
        <div class="category-discount-progress__bar">
            <div class="category-discount-progress__fill category-discount-progress__fill--cart"
                :style="{ width: cartPercent + '%' }"></div>
            <div class="category-discount-progress__fill category-discount-progress__fill--adding"
                :style="{ left: cartPercent + '%', width: addingPercent + '%' }"></div>
            <div v-for="(tier, index) in rule.tiers" :key="index"
                class="category-discount-progress__marker"
                :class="{ 'category-discount-progress__marker--reached': total >= tier.minQty }"
                :style="{ left: positionOf(tier.minQty) + '%' }">
            </div>
        </div>
        <div class="category-discount-progress__labels">
            <span v-for="(tier, index) in rule.tiers" :key="index"
                class="category-discount-progress__label"
                :class="{ 'category-discount-progress__label--reached': total >= tier.minQty }"
                :style="{ left: positionOf(tier.minQty) + '%' }">
                <b>{{ tier.percent }}&nbsp;%</b>
                <small>{{ $translate("OD3dprimaV2::Template.categoryDiscountQty", { qty: tier.minQty }) }}</small>
            </span>
        </div>
        <div class="category-discount-progress__footer">
            <small class="category-discount-progress__text">
                <b v-if="unlockedTier" class="category-discount-progress__unlock">
                    {{ $translate("OD3dprimaV2::Template.categoryDiscountProgressUnlock", { percent: unlockedTier.percent }) }}
                </b>
                <template v-if="nextTier">
                    {{ $translate("OD3dprimaV2::Template.categoryDiscountProgressNext", { qty: nextTier.minQty - total, percent: nextTier.percent }) }}
                </template>
                <template v-else-if="!unlockedTier">
                    {{ $translate("OD3dprimaV2::Template.categoryDiscountProgressMax", { percent: reachedTier.percent }) }}
                </template>
                <span v-if="inCart > 0" class="category-discount-progress__in-cart">
                    {{ $translate("OD3dprimaV2::Template.categoryDiscountProgressInCart", { count: inCart }) }}
                </span>
            </small>
            <small class="category-discount-progress__hint">{{ $translate("OD3dprimaV2::Template.categoryDiscountHint") }}</small>
        </div>
    </div>
</template>

<script>
import { parseCategoryDiscountRules, categoryIdsOf } from "~/app/helper/categoryDiscount";

export default {
    name: "category-discount-progress",

    props: {
        rules: {
            type: String,
            default: ""
        },
        categoryIds: {
            type: Array,
            default: () => []
        },
        adding: {
            type: Number,
            default: 0
        },
        variationId: {
            type: Number,
            default: null
        }
    },

    computed: {
        rule() {
            const ids = this.categoryIds.map(id => parseInt(id));
            return parseCategoryDiscountRules(this.rules).find(rule => ids.includes(rule.catId)) || null;
        },
        inCart() {
            const catId = this.rule.catId;
            return (this.$store.state.basket.items || [])
                .filter(basketItem => (this.variationId && basketItem.variationId === this.variationId)
                    || categoryIdsOf(basketItem.variation && basketItem.variation.data).includes(catId))
                .reduce((sum, basketItem) => sum + (parseFloat(basketItem.quantity) || 0), 0);
        },
        total() {
            return this.inCart + this.adding;
        },
        scaleMax() {
            return this.rule.tiers[this.rule.tiers.length - 1].minQty;
        },
        cartPercent() {
            return this.positionOf(this.inCart);
        },
        addingPercent() {
            return this.positionOf(this.total) - this.cartPercent;
        },
        nextTier() {
            return this.rule.tiers.find(tier => tier.minQty > this.total) || null;
        },
        reachedTier() {
            return this.highestTierFor(this.total);
        },
        unlockedTier() {
            const cartTier = this.highestTierFor(this.inCart);
            const reachedTier = this.reachedTier;
            return this.adding > 0 && reachedTier && (!cartTier || reachedTier.minQty > cartTier.minQty) ? reachedTier : null;
        }
    },

    methods: {
        highestTierFor(qty) {
            return [...this.rule.tiers].reverse().find(tier => tier.minQty <= qty) || null;
        },
        positionOf(qty) {
            return Math.min(100, Math.max(0, qty / this.scaleMax * 100));
        }
    }
};
</script>
